import { Directive, ElementRef, HostListener, inject, input } from '@angular/core';

@Directive({
  selector: 'img[appImgFallback]',
  standalone: true,
})
export class ImgFallbackDirective {
  private readonly element = inject(ElementRef);


  readonly fallback = input<string>('', { alias: "appImgFallback" });

  @HostListener('error')
  displayFallbackImg(): void {
    const img: HTMLImageElement = this.element.nativeElement;
    const fallback = this.fallback();
    if (img.src !== fallback) {
      img.src = fallback;
    }
  }
}
